// import React, { useState, useRef, useEffect } from 'react';
// import { Search, Tune, Close, LocationOn } from '@mui/icons-material';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import {
//   Box,
//   IconButton,
//   InputBase,
//   Paper,
//   Typography,
//   Divider,
//   Slider,
//   Button,
// } from '@mui/material';
// import { useNavigate, useLocation } from 'react-router-dom';

// // ── Brand colors (matching TopToolbar.jsx) ────────────────────────────────────
// const PRIMARY_BROWN = '#6B3620';
// const PRIMARY_BROWN_HOVER = '#4A2315';

// // Purchase price ranges
// const purchaseRangeButtons = [
//   { label: '5L - 10L', min: 500000, max: 1000000 },
//   { label: '10L - 20L', min: 1000000, max: 2000000 },
//   { label: '20L - 30L', min: 2000000, max: 3000000 },
//   { label: '30L - 40L', min: 3000000, max: 4000000 },
//   { label: '40L - 50L', min: 4000000, max: 5000000 },
//   { label: '50L - 60L', min: 5000000, max: 6000000 },
//   { label: '60L - 70L', min: 6000000, max: 7000000 },
//   { label: '70L - 80L', min: 7000000, max: 8000000 },
//   { label: '80L - 90L', min: 8000000, max: 9000000 },
//   { label: '90L - 1CR', min: 9000000, max: 10000000 },
//   { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
//   { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
//   { label: '1.5CR - 1.75CR', min: 15000000, max: 17500000 },
//   { label: '1.75CR - 2CR', min: 17500000, max: 20000000 },
//   { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
//   { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
//   { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
//   { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
//   { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
//   { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
//   { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
//   { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
//   { label: '6CR - 8CR', min: 60000000, max: 80000000 },
//   { label: '8CR - 9CR', min: 80000000, max: 90000000 },
//   { label: '9CR - 10CR', min: 90000000, max: 100000000 },
//   { label: '10CR - 15CR', min: 100000000, max: 150000000 },
//   { label: '15CR - 20CR', min: 150000000, max: 200000000 },
//   { label: '20CR - 25CR', min: 200000000, max: 250000000 },
//   { label: '25CR - 30CR', min: 250000000, max: 300000000 },
//   { label: '30CR - 40CR', min: 300000000, max: 400000000 },
//   { label: '40CR - 50CR', min: 400000000, max: 500000000 },
//   { label: '50CR - 60CR', min: 500000000, max: 600000000 },
//   { label: '60CR - 70CR', min: 600000000, max: 700000000 },
//   { label: '70CR - 80CR', min: 700000000, max: 800000000 },
//   { label: '80CR - 90CR', min: 800000000, max: 900000000 },
//   { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
//   { label: '100CR - 120CR', min: 1000000000, max: 1200000000 },
//   { label: '120CR - 140CR', min: 1200000000, max: 1400000000 },
//   { label: '140CR - 160CR', min: 1400000000, max: 1600000000 },
//   { label: '160CR - 190CR', min: 1600000000, max: 1900000000 },
//   { label: '190CR - 200CR', min: 1900000000, max: 2000000000 },
//   { label: '200CR - 250CR', min: 2000000000, max: 2500000000 },
//   { label: '250CR - 300CR', min: 2500000000, max: 3000000000 },
//   { label: '300CR - 350CR', min: 3000000000, max: 3500000000 },
//   { label: '350CR - 400CR', min: 3500000000, max: 4000000000 },
//   { label: '400CR - 450CR', min: 4000000000, max: 4500000000 },
//   { label: '450CR - 500CR', min: 4500000000, max: 5000000000 },
//   { label: '500CR - 550CR', min: 5000000000, max: 5500000000 },
//   { label: '550CR - 600CR', min: 5500000000, max: 6000000000 },
//   { label: '600CR - 650CR', min: 6000000000, max: 6500000000 },
//   { label: '650CR - 700CR', min: 6500000000, max: 7000000000 },
//   { label: '700CR - 750CR', min: 7000000000, max: 7500000000 },
//   { label: '750CR - 800CR', min: 7500000000, max: 8000000000 },
//   { label: '800CR - 850CR', min: 8000000000, max: 8500000000 },
//   { label: '850CR - 900CR', min: 8500000000, max: 9000000000 },
//   { label: '900CR - 1000CR', min: 9000000000, max: 10000000000 },
//   { label: '1000CR - 1500CR', min: 10000000000, max: 15000000000 },
//   { label: '1500CR - 2000CR', min: 15000000000, max: 20000000000 },
//   { label: '2000CR - 2500CR', min: 20000000000, max: 25000000000 },
//   { label: '2500CR - 3000CR', min: 25000000000, max: 30000000000 },
//   { label: '3000CR - 4000CR', min: 30000000000, max: 40000000000 },
//   { label: '4000CR - 5000CR', min: 40000000000, max: 50000000000 },
//   { label: '5000CR - 6000CR', min: 50000000000, max: 60000000000 },
//   { label: '6000CR - 7000CR', min: 60000000000, max: 70000000000 },
//   { label: '7000CR - 8000CR', min: 70000000000, max: 80000000000 },
//   { label: '8000CR - 9000CR', min: 80000000000, max: 90000000000 },
//   { label: '9000CR - 10000CR+++', min: 90000000000, max: 100000000000 },
//   {
//     label: '6521498993CR - 6631498993CR',
//     min: 6521498993592095,
//     max: 6631498993592095
//   },
//   {
//     label: '1420434756CR - 1450434756CR',
//     min: 1420434756968427,
//     max: 1450434756968427
//   },
//   {
//     label: '1680919122CR+++',
//     min: 16809191221661276,
//     max: 16809191221661276
//   },
//   { label: '2663780CR+++', min: 26637800628190116, max: 26637800628190116 }
// ];

// // Rent price ranges
// const rentRangeButtons = [
//   { label: '1K - 2K', min: 1000, max: 2000 },
//   { label: '2K - 3K', min: 2000, max: 3000 },
//   { label: '3K - 4K', min: 3000, max: 4000 },
//   { label: '4K - 5K', min: 4000, max: 5000 },
//   { label: '5K - 10K', min: 5000, max: 10000 },
//   { label: '10K - 15K', min: 10000, max: 15000 },
//   { label: '15K - 20K', min: 15000, max: 20000 },
//   { label: '20K - 25K', min: 20000, max: 25000 },
//   { label: '25K - 30K', min: 25000, max: 30000 },
//   { label: '30K - 35K', min: 30000, max: 35000 },
//   { label: '35K - 40K', min: 35000, max: 40000 },
//   { label: '40K - 50K', min: 40000, max: 50000 },
//   { label: '50K - 60K', min: 50000, max: 60000 },
//   { label: '60K - 70K', min: 60000, max: 70000 },
//   { label: '70K - 80K', min: 70000, max: 80000 },
//   { label: '80K - 90K', min: 80000, max: 90000 },
//   { label: '90K - 1L', min: 90000, max: 100000 },
//   { label: '1L - 1.25L', min: 100000, max: 125000 },
//   { label: '1.25L - 1.5L', min: 125000, max: 150000 },
//   { label: '1.5L - 2L', min: 150000, max: 200000 },
//   { label: '2L - 2.5L', min: 200000, max: 250000 },
//   { label: '2.5L - 3L', min: 250000, max: 300000 },
//   { label: '3L - 3.5L', min: 300000, max: 350000 },
//   { label: '3.5L - 4L', min: 350000, max: 400000 },
//   { label: '4L - 4.5L', min: 400000, max: 450000 },
//   { label: '4.5L - 5L', min: 450000, max: 500000 },
//   { label: '5L - 6L', min: 500000, max: 600000 },
//   { label: '6L - 7L', min: 600000, max: 700000 },
//   { label: '7L - 8L', min: 700000, max: 800000 },
//   { label: '8L - 9L', min: 800000, max: 900000 },
//   { label: '9L - 10L', min: 900000, max: 1000000 },
//   { label: '10L - 15L', min: 1000000, max: 1500000 },
//   { label: '15L - 20L', min: 1500000, max: 2000000 },
//   { label: '20L - 25L', min: 2000000, max: 2500000 },
//   { label: '25L - 30L', min: 2500000, max: 3000000 },
//   { label: '30L - 40L', min: 3000000, max: 4000000 },
//   { label: '40L - 50L', min: 4000000, max: 5000000 },
//   { label: '50L - 60L', min: 5000000, max: 6000000 },
//   { label: '60L - 70L', min: 6000000, max: 7000000 },
//   { label: '70L - 80L', min: 7000000, max: 8000000 },
//   { label: '80L - 90L', min: 8000000, max: 9000000 },
//   { label: '90L - 1CR', min: 9000000, max: 10000000 },
//   { label: '1CR - 1.2CR', min: 10000000, max: 12000000 },
//   { label: '1.2CR - 1.4CR', min: 12000000, max: 14000000 },
//   { label: '1.4CR - 1.6CR', min: 14000000, max: 16000000 },
//   { label: '1.6CR - 1.8CR', min: 16000000, max: 18000000 },
//   { label: '1.8CR - 2CR', min: 18000000, max: 20000000 },
//   { label: '2CR - 2.2CR', min: 20000000, max: 22000000 },
//   { label: '2.2CR - 2.4CR', min: 22000000, max: 24000000 },
//   { label: '2.4CR - 2.6CR', min: 24000000, max: 26000000 },
//   { label: '2.6CR - 2.8CR', min: 26000000, max: 28000000 },
//   { label: '2.8CR - 3CR', min: 28000000, max: 30000000 },
//   { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
//   { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
//   { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
//   { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
//   { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
//   { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
//   { label: '6CR - 6.5CR', min: 60000000, max: 65000000 },
//   { label: '6.5CR - 7CR', min: 65000000, max: 70000000 },
//   { label: '7CR - 7.5CR', min: 70000000, max: 75000000 },
//   { label: '7.5CR - 8CR', min: 75000000, max: 80000000 },
//   { label: '8CR - 8.5CR', min: 80000000, max: 85000000 },
//   { label: '8.5CR - 9CR', min: 85000000, max: 90000000 },
//   { label: '9CR - 9.5CR', min: 90000000, max: 95000000 },
//   { label: '9.5CR - 10CR', min: 95000000, max: 100000000 },
//   { label: '10CR - 15CR', min: 100000000, max: 150000000 },
//   { label: '15CR - 20CR', min: 150000000, max: 200000000 },
//   { label: '20CR - 30CR', min: 200000000, max: 300000000 },
//   { label: '30CR - 40CR', min: 300000000, max: 400000000 },
//   { label: '40CR - 50CR', min: 400000000, max: 500000000 },
//   { label: '50CR - 60CR', min: 500000000, max: 600000000 },
//   { label: '60CR - 70CR', min: 600000000, max: 700000000 },
//   { label: '70CR - 80CR', min: 700000000, max: 800000000 },
//   { label: '80CR - 90CR', min: 800000000, max: 900000000 },
//   { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
//   { label: '100CR+++', min: 1000000000, max: 9999999999 }
// ];

// // Lease price ranges
// const leaseRangeButtons = [
//   { label: '1L - 2L', min: 100000, max: 200000 },
//   { label: '2L - 3L', min: 200000, max: 300000 },
//   { label: '3L - 4L', min: 300000, max: 400000 },
//   { label: '4L - 5L', min: 400000, max: 500000 },
//   { label: '5L - 10L', min: 500000, max: 1000000 },
//   { label: '10L - 15L', min: 1000000, max: 1500000 },
//   { label: '15L - 20L', min: 1500000, max: 2000000 },
//   { label: '20L - 25L', min: 2000000, max: 2500000 },
//   { label: '25L - 30L', min: 2500000, max: 3000000 },
//   { label: '30L - 35L', min: 3000000, max: 3500000 },
//   { label: '35L - 40L', min: 3500000, max: 4000000 },
//   { label: '40L - 50L', min: 4000000, max: 5000000 },
//   { label: '50L - 60L', min: 5000000, max: 6000000 },
//   { label: '60L - 70L', min: 6000000, max: 7000000 },
//   { label: '70L - 80L', min: 7000000, max: 8000000 },
//   { label: '80L - 90L', min: 8000000, max: 9000000 },
//   { label: '90L - 1CR', min: 9000000, max: 10000000 },
//   { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
//   { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
//   { label: '1.5CR - 2CR', min: 15000000, max: 20000000 },
//   { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
//   { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
//   { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
//   { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
//   { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
//   { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
//   { label: '5CR - 6CR', min: 50000000, max: 60000000 },
//   { label: '6CR - 7CR', min: 60000000, max: 70000000 },
//   { label: '7CR - 8CR', min: 70000000, max: 80000000 },
//   { label: '8CR - 9CR', min: 80000000, max: 90000000 },
//   { label: '9CR - 10CR', min: 90000000, max: 100000000 },
//   { label: '10CR - 15CR', min: 100000000, max: 150000000 },
//   { label: '15CR - 20CR', min: 150000000, max: 200000000 },
//   { label: '20CR - 25CR', min: 200000000, max: 250000000 },
//   { label: '25CR - 30CR', min: 250000000, max: 300000000 },
//   { label: '30CR - 40CR', min: 300000000, max: 400000000 },
//   { label: '40CR - 50CR', min: 400000000, max: 500000000 },
//   { label: '50CR - 60CR', min: 500000000, max: 600000000 },
//   { label: '60CR - 70CR', min: 600000000, max: 700000000 },
//   { label: '70CR - 80CR', min: 700000000, max: 800000000 },
//   { label: '80CR - 90CR', min: 800000000, max: 900000000 },
//   { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
//   { label: '100CR+++', min: 1000000000, max: 9999999999 }
// ];

// const getRangeButtons = (pathname) => {
//   if (pathname.includes('/Buy-details') || pathname.includes('/Buy-saves') || pathname.includes('/postbank_detail') || pathname.includes('/new-saves') || pathname.includes('/new-list') || pathname.includes('/hot-property-details') || pathname.includes('/hot-property-saves')) {
//     return purchaseRangeButtons;
//   } else if (pathname.includes('/details') || pathname.includes('/rent-saves')) {
//     return rentRangeButtons;
//   } else if (pathname.includes('/lease_details') || pathname.includes('/lease_save')) {
//     return leaseRangeButtons;
//   }
//   return purchaseRangeButtons;
// };

// const getInitialMax = (pathname) => {
//   if (pathname.includes('/details') || pathname.includes('/rent-saves')) return 9999999999;
//   if (pathname.includes('/lease_details') || pathname.includes('/lease_save')) return 9999999999;
//   return 100000000000;
// };

// const formatPrice = (value) => {
//   if (value === 0) return 'No Min';
//   if (value >= 10000000) return `${value / 10000000} Cr`;
//   if (value >= 100000) return `${value / 100000} L`;
//   if (value >= 1000) return `${value / 1000} K`;
//   return value;
// };

// const CustomSearchBar = ({ value, onChange, onPriceFilterChange }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const paperRef = useRef(null);
//   const modalRef = useRef(null);

//   const [anchorEl, setAnchorEl] = useState(null);
//   const [selectedPriceRange, setSelectedPriceRange] = useState(null);
//   const [tempSelectedRange, setTempSelectedRange] = useState(null);
//   const [customRange, setCustomRange] = useState([0, getInitialMax(location.pathname)]);
//   const [sliderMax, setSliderMax] = useState(getInitialMax(location.pathname));

//   const currentRangeButtons = getRangeButtons(location.pathname);

//   // Hide filter button on specific routes
//   const hideFilterRoutes = ["/user-buy", "/user-bestdeals", "/user-rent", "/user-lease"];
//   const hideFilter = hideFilterRoutes.includes(location.pathname);

//   // Prevent body scroll when modal is open
//   useEffect(() => {
//     if (anchorEl) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [anchorEl]);

//   const handleTuneClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleMenuClose = () => setAnchorEl(null);

//   useEffect(() => {
//     if (anchorEl) setTempSelectedRange(selectedPriceRange);
//   }, [anchorEl, selectedPriceRange]);

//   const handleRangeButtonSelect = (range) => {
//     setCustomRange([range.min, range.max]);
//     setTempSelectedRange({
//       label: range.label,
//       min: range.min,
//       max: range.max,
//     });
//     setSliderMax(range.max > sliderMax ? range.max : sliderMax);
//   };

//   const handleSliderChangeTemp = (e, newValue) => {
//     setCustomRange(newValue);
//     setTempSelectedRange({
//       label: `${formatPrice(newValue[0])} - ${formatPrice(newValue[1])}`,
//       min: newValue[0],
//       max: newValue[1],
//     });
//     if (newValue[1] > sliderMax) setSliderMax(newValue[1]);
//   };

//   const handleApplyFilter = () => {
//     setSelectedPriceRange(tempSelectedRange);
//     if (onPriceFilterChange) onPriceFilterChange(tempSelectedRange);
//     handleMenuClose();
//   };

//   const clearPriceFilter = () => {
//     setSelectedPriceRange(null);
//     setTempSelectedRange(null);
//     setCustomRange([0, getInitialMax(location.pathname)]);
//     setSliderMax(getInitialMax(location.pathname));
//     if (onPriceFilterChange) onPriceFilterChange(null);
//     handleMenuClose();
//   };

//   const handleClearInput = () => {
//     onChange({ target: { value: '' } });
//   };

//   const handleSubmit = (e) => e.preventDefault();

//   return (
//     <Box sx={{ position: 'relative' }}>
//       <Paper
//         ref={paperRef}
//         component="form"
//         elevation={0}
//         onSubmit={handleSubmit}
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           height: 32,
//           borderRadius: '30px',
//           px: 0.8,
//           backgroundColor: '#f2f5f7',
//           border: '1px solid black',
//           mx: 0.5,
//           my: 0,
//         }}
//       >
//         {/* Back Button */}
//         <IconButton
//           onClick={() => navigate(-1)}
//           size="small"
//           sx={{ color: 'black', p: 0.5 }}
//         >
//           <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
//         </IconButton>

//         {/* Search Input */}
//         <InputBase
//           sx={{ ml: 1, flex: 1, fontSize: '13.5px' }}
//           placeholder="Search location..."
//           value={value}
//           onChange={onChange}
//         />

//         {/* Clear Input */}
//         {value && (
//           <IconButton
//             onClick={handleClearInput}
//             size="small"
//             sx={{ color: 'black', p: 0.5 }}
//           >
//             <Close sx={{ fontSize: 18 }} />
//           </IconButton>
//         )}

//         {/* Search Icon */}
//         <IconButton
//           type="submit"
//           size="small"
//           sx={{ color: 'black', p: 0.5 }}
//         >
//           <Search sx={{ fontSize: 18 }} />
//         </IconButton>

//         {/* Filter Icon - hidden on specific routes */}
//         {!hideFilter && (
//           <IconButton
//             sx={{ color: 'black', p: 0.5 }}
//             onClick={handleTuneClick}
//             aria-label="filter"
//             size="small"
//           >
//             <Tune sx={{ fontSize: 18 }} />
//           </IconButton>
//         )}
//       </Paper>

//       {/* Price Filter Modal - Fixed position relative to viewport */}
//       {!hideFilter && anchorEl && (
//         <>
//           {/* Backdrop */}
//           <div
//             style={{
//               position: 'fixed',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               backgroundColor: 'rgba(0,0,0,0.5)',
//               zIndex: 1299,
//             }}
//             onClick={handleMenuClose}
//           />

//           <div
//             ref={modalRef}
//             style={{
//               position: 'fixed',
//               top: '43%',
//               left: '50%',
//               transform: 'translate(-50%, -50%)',
//               zIndex: 1300,
//               backgroundColor: 'white',
//               width: '330px',
//               maxHeight: '70vh',
//               boxShadow: '0px 5px 15px rgba(0,0,0,0.2)',
//               display: 'flex',
//               flexDirection: 'column',
//               overflow: 'hidden',
//               borderRadius: '10px'
//             }}
//           >
//             {/* Title — brown text (matching TopToolbar) */}
//             <Typography
//               variant="subtitle2"
//               sx={{
//                 px: 2,
//                 py: 1,
//                 fontWeight: 'bold',
//                 flexShrink: 0,
//                 color: PRIMARY_BROWN,     // ✅ brand brown
//               }}
//             >
//               Select Price Range
//             </Typography>
//             <Divider sx={{ flexShrink: 0 }} />

//             {/* Slider — brown thumb, track, and focus ring */}
//             <Box sx={{ px: 2, py: 2, flexShrink: 0 }}>
//               <Slider
//                 value={customRange}
//                 onChange={handleSliderChangeTemp}
//                 min={0}
//                 max={sliderMax}
//                 step={1000}
//                 valueLabelDisplay="auto"
//                 valueLabelFormat={(value) => formatPrice(value)}
//                 sx={{
//                   color: PRIMARY_BROWN,                       // ✅ brand brown
//                   '& .MuiSlider-thumb': {
//                     backgroundColor: PRIMARY_BROWN,           // ✅ brown thumb
//                     '&:hover, &.Mui-focusVisible': {
//                       boxShadow: `0 0 0 8px rgba(107, 54, 32, 0.16)`,
//                     },
//                   },
//                   '& .MuiSlider-track': {
//                     backgroundColor: PRIMARY_BROWN,           // ✅ brown track
//                     borderColor: PRIMARY_BROWN,
//                   },
//                   '& .MuiSlider-rail': {
//                     backgroundColor: '#d1d1d1',
//                   },
//                   '& .MuiSlider-valueLabel': {
//                     backgroundColor: PRIMARY_BROWN,           // ✅ brown tooltip
//                   },
//                 }}
//               />
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
//                 <Typography variant="caption">{formatPrice(customRange[0])}</Typography>
//                 <Typography variant="caption">{formatPrice(customRange[1])}</Typography>
//               </Box>
//             </Box>

//             <Divider sx={{ flexShrink: 0 }} />

//             {/* Scrollable buttons container */}
//             <Box
//               sx={{
//                 px: 2,
//                 py: 2,
//                 flex: 1,
//                 minHeight: 0,
//                 overflowY: 'auto',
//                 // 👇 thin brown-tinted scrollbar (subtle)
//                 '&::-webkit-scrollbar': { width: 6 },
//                 '&::-webkit-scrollbar-thumb': {
//                   background: 'rgba(107, 54, 32, 0.35)',
//                   borderRadius: 3,
//                 },
//                 '&::-webkit-scrollbar-thumb:hover': {
//                   background: 'rgba(107, 54, 32, 0.55)',
//                 },
//               }}
//             >
//               <Box
//                 sx={{
//                   display: 'grid',
//                   gridTemplateColumns: 'repeat(3, 1fr)',
//                   gap: 1,
//                 }}
//               >
//                 {currentRangeButtons.map((range) => {
//                   const isRangeActive = tempSelectedRange?.label === range.label;
//                   return (
//                     <Button
//                       key={range.label}
//                       variant={isRangeActive ? 'contained' : 'outlined'}
//                       size="small"
//                       sx={{
//                         borderRadius: '16px',
//                         textTransform: 'none',
//                         fontSize: '0.6rem',
//                         minWidth: 'auto',
//                         px: 1,
//                         py: 0.5,
//                         minHeight: '30px',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',

//                         // ✅ Brand colors — matches TopToolbar.jsx
//                         backgroundColor: isRangeActive
//                           ? PRIMARY_BROWN
//                           : 'transparent',
//                         color: isRangeActive ? '#fff' : PRIMARY_BROWN,
//                         borderColor: PRIMARY_BROWN,

//                         '&:hover': {
//                           backgroundColor: isRangeActive
//                             ? PRIMARY_BROWN_HOVER
//                             : 'rgba(107, 54, 32, 0.08)',
//                           borderColor: PRIMARY_BROWN_HOVER,
//                         },
//                       }}
//                       onClick={() => handleRangeButtonSelect(range)}
//                     >
//                       {range.label}
//                     </Button>
//                   );
//                 })}
//               </Box>
//             </Box>

//             <Divider sx={{ flexShrink: 0 }} />

//             {/* Footer buttons — CLEAR & APPLY in brand brown */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 px: 2,
//                 py: 1,
//                 flexShrink: 0,
//               }}
//             >
//               <Button
//                 onClick={clearPriceFilter}
//                 sx={{
//                   color: PRIMARY_BROWN,
//                   fontWeight: 'bold',
//                   '&:hover': { backgroundColor: 'rgba(107, 54, 32, 0.08)' },
//                 }}
//               >
//                 CLEAR
//               </Button>
//               <Button
//                 onClick={handleApplyFilter}
//                 variant="contained"
//                 sx={{
//                   backgroundColor: PRIMARY_BROWN,
//                   fontWeight: 'bold',
//                   '&:hover': { backgroundColor: PRIMARY_BROWN_HOVER },
//                 }}
//               >
//                 APPLY
//               </Button>
//             </Box>
//           </div>
//         </>
//       )}
//     </Box>
//   );
// };

// export default CustomSearchBar;



import React, { useState, useRef, useEffect } from 'react';
import { Search, Tune, Close, LocationOn } from '@mui/icons-material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Box,
  IconButton,
  InputBase,
  Paper,
  Typography,
  Divider,
  Slider,
  Button,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

// ── Brand colors (matching TopToolbar.jsx) ────────────────────────────────────
const PRIMARY_BROWN = '#6B3620';
const PRIMARY_BROWN_HOVER = '#4A2315';

// ─────────────────────────────────────────────────────────────────────────────
// UNIVERSAL SEARCH PARSER
// Detects: pincode | price | propertyType | location (area/city)
// Also supports combined queries e.g. "3BHK in Bandra under 2cr 400001"
// ─────────────────────────────────────────────────────────────────────────────

const PROPERTY_TYPES = [
  'flat', 'apartment', 'villa', 'house', 'plot', 'land',
  'office', 'shop', 'warehouse', 'godown', 'penthouse',
  'studio', 'duplex', 'farmhouse', 'commercial', 'residential',
  '1bhk', '2bhk', '3bhk', '4bhk', '5bhk',
  '1 bhk', '2 bhk', '3 bhk', '4 bhk', '5 bhk',
];

const UNIT_MULTIPLIERS = {
  k: 1_000,
  thousand: 1_000,
  l: 100_000,
  lakh: 100_000,
  lac: 100_000,
  cr: 10_000_000,
  crore: 10_000_000,
};

const PRICE_TOKEN_REGEX = /(\d+(?:\.\d+)?)\s*(lakh|lac|crore|cr|l|k|thousand)?/i;
const PRICE_UNIT_HINT = /(lakh|lac|cr|crore|k\b|thousand)/i;

/**
 * Parse a free-text search query into a structured filter object.
 * Returns: { type, value, ...extracted fields, raw }
 */
export const parseSearchQuery = (raw) => {
  const query = (raw || '').trim();
  if (!query) {
    return { type: 'empty', raw: query };
  }

  const result = { raw: query };
  let remaining = query;

  // 1) Pincode (6-digit Indian pincode)
  const pinMatch = query.match(/\b\d{6}\b/);
  if (pinMatch) {
    result.pincode = pinMatch[0];
    remaining = remaining.replace(pinMatch[0], ' ');
  }

  // 2) Price (only if it looks like a price: has a unit OR is 4+ digits)
  const priceMatch = remaining.match(PRICE_TOKEN_REGEX);
  if (priceMatch) {
    const num = parseFloat(priceMatch[1]);
    const unit = (priceMatch[2] || '').toLowerCase();
    const hasUnit = PRICE_UNIT_HINT.test(priceMatch[0]);
    const isBigNumber = !unit && num >= 1000;
    if (hasUnit || isBigNumber) {
      result.price = Math.round(num * (UNIT_MULTIPLIERS[unit] || 1));
      remaining = remaining.replace(priceMatch[0], ' ');
    }
  }

  // 3) Property type
  const lowerRemaining = remaining.toLowerCase();
  const matchedType = PROPERTY_TYPES.find((t) => lowerRemaining.includes(t));
  if (matchedType) {
    result.propertyType = matchedType;
    remaining = remaining.replace(new RegExp(matchedType, 'i'), ' ');
  }

  // 4) What's left → location (strip filler words)
  const location = remaining
    .replace(/\b(in|at|near|under|below|above|around|for|with|and|of|the)\b/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (location) {
    result.location = location;
  }

  // Decide a "primary" type so parent can branch easily if needed
  if (result.pincode) result.type = 'pincode';
  else if (result.propertyType) result.type = 'propertyType';
  else if (result.price) result.type = 'price';
  else if (result.location) result.type = 'location';
  else result.type = 'unknown';

  return result;
};

// ── Purchase price ranges ─────────────────────────────────────────────────────
const purchaseRangeButtons = [
  { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 20L', min: 1000000, max: 2000000 },
  { label: '20L - 30L', min: 2000000, max: 3000000 },
  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },
  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 1.75CR', min: 15000000, max: 17500000 },
  { label: '1.75CR - 2CR', min: 17500000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
  { label: '6CR - 8CR', min: 60000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },
  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
  { label: '100CR - 120CR', min: 1000000000, max: 1200000000 },
  { label: '120CR - 140CR', min: 1200000000, max: 1400000000 },
  { label: '140CR - 160CR', min: 1400000000, max: 1600000000 },
  { label: '160CR - 190CR', min: 1600000000, max: 1900000000 },
  { label: '190CR - 200CR', min: 1900000000, max: 2000000000 },
  { label: '200CR - 250CR', min: 2000000000, max: 2500000000 },
  { label: '250CR - 300CR', min: 2500000000, max: 3000000000 },
  { label: '300CR - 350CR', min: 3000000000, max: 3500000000 },
  { label: '350CR - 400CR', min: 3500000000, max: 4000000000 },
  { label: '400CR - 450CR', min: 4000000000, max: 4500000000 },
  { label: '450CR - 500CR', min: 4500000000, max: 5000000000 },
  { label: '500CR - 550CR', min: 5000000000, max: 5500000000 },
  { label: '550CR - 600CR', min: 5500000000, max: 6000000000 },
  { label: '600CR - 650CR', min: 6000000000, max: 6500000000 },
  { label: '650CR - 700CR', min: 6500000000, max: 7000000000 },
  { label: '700CR - 750CR', min: 7000000000, max: 7500000000 },
  { label: '750CR - 800CR', min: 7500000000, max: 8000000000 },
  { label: '800CR - 850CR', min: 8000000000, max: 8500000000 },
  { label: '850CR - 900CR', min: 8500000000, max: 9000000000 },
  { label: '900CR - 1000CR', min: 9000000000, max: 10000000000 },
  { label: '1000CR - 1500CR', min: 10000000000, max: 15000000000 },
  { label: '1500CR - 2000CR', min: 15000000000, max: 20000000000 },
  { label: '2000CR - 2500CR', min: 20000000000, max: 25000000000 },
  { label: '2500CR - 3000CR', min: 25000000000, max: 30000000000 },
  { label: '3000CR - 4000CR', min: 30000000000, max: 40000000000 },
  { label: '4000CR - 5000CR', min: 40000000000, max: 50000000000 },
  { label: '5000CR - 6000CR', min: 50000000000, max: 60000000000 },
  { label: '6000CR - 7000CR', min: 60000000000, max: 70000000000 },
  { label: '7000CR - 8000CR', min: 70000000000, max: 80000000000 },
  { label: '8000CR - 9000CR', min: 80000000000, max: 90000000000 },
  { label: '9000CR - 10000CR+++', min: 90000000000, max: 100000000000 },
  { label: '6521498993CR - 6631498993CR', min: 6521498993592095, max: 6631498993592095 },
  { label: '1420434756CR - 1450434756CR', min: 1420434756968427, max: 1450434756968427 },
  { label: '1680919122CR+++', min: 16809191221661276, max: 16809191221661276 },
  { label: '2663780CR+++', min: 26637800628190116, max: 26637800628190116 },
];

const rentRangeButtons = [
  { label: '1K - 2K', min: 1000, max: 2000 },
  { label: '2K - 3K', min: 2000, max: 3000 },
  { label: '3K - 4K', min: 3000, max: 4000 },
  { label: '4K - 5K', min: 4000, max: 5000 },
  { label: '5K - 10K', min: 5000, max: 10000 },
  { label: '10K - 15K', min: 10000, max: 15000 },
  { label: '15K - 20K', min: 15000, max: 20000 },
  { label: '20K - 25K', min: 20000, max: 25000 },
  { label: '25K - 30K', min: 25000, max: 30000 },
  { label: '30K - 35K', min: 30000, max: 35000 },
  { label: '35K - 40K', min: 35000, max: 40000 },
  { label: '40K - 50K', min: 40000, max: 50000 },
  { label: '50K - 60K', min: 50000, max: 60000 },
  { label: '60K - 70K', min: 60000, max: 70000 },
  { label: '70K - 80K', min: 70000, max: 80000 },
  { label: '80K - 90K', min: 80000, max: 90000 },
  { label: '90K - 1L', min: 90000, max: 100000 },
  { label: '1L - 1.25L', min: 100000, max: 125000 },
  { label: '1.25L - 1.5L', min: 125000, max: 150000 },
  { label: '1.5L - 2L', min: 150000, max: 200000 },
  { label: '2L - 2.5L', min: 200000, max: 250000 },
  { label: '2.5L - 3L', min: 250000, max: 300000 },
  { label: '3L - 3.5L', min: 300000, max: 350000 },
  { label: '3.5L - 4L', min: 350000, max: 400000 },
  { label: '4L - 4.5L', min: 400000, max: 450000 },
  { label: '4.5L - 5L', min: 450000, max: 500000 },
  { label: '5L - 6L', min: 500000, max: 600000 },
  { label: '6L - 7L', min: 600000, max: 700000 },
  { label: '7L - 8L', min: 700000, max: 800000 },
  { label: '8L - 9L', min: 800000, max: 900000 },
  { label: '9L - 10L', min: 900000, max: 1000000 },
  { label: '10L - 15L', min: 1000000, max: 1500000 },
  { label: '15L - 20L', min: 1500000, max: 2000000 },
  { label: '20L - 25L', min: 2000000, max: 2500000 },
  { label: '25L - 30L', min: 2500000, max: 3000000 },
  { label: '30L - 40L', min: 3000000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },
  { label: '1CR - 1.2CR', min: 10000000, max: 12000000 },
  { label: '1.2CR - 1.4CR', min: 12000000, max: 14000000 },
  { label: '1.4CR - 1.6CR', min: 14000000, max: 16000000 },
  { label: '1.6CR - 1.8CR', min: 16000000, max: 18000000 },
  { label: '1.8CR - 2CR', min: 18000000, max: 20000000 },
  { label: '2CR - 2.2CR', min: 20000000, max: 22000000 },
  { label: '2.2CR - 2.4CR', min: 22000000, max: 24000000 },
  { label: '2.4CR - 2.6CR', min: 24000000, max: 26000000 },
  { label: '2.6CR - 2.8CR', min: 26000000, max: 28000000 },
  { label: '2.8CR - 3CR', min: 28000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 5.5CR', min: 50000000, max: 55000000 },
  { label: '5.5CR - 6CR', min: 55000000, max: 60000000 },
  { label: '6CR - 6.5CR', min: 60000000, max: 65000000 },
  { label: '6.5CR - 7CR', min: 65000000, max: 70000000 },
  { label: '7CR - 7.5CR', min: 70000000, max: 75000000 },
  { label: '7.5CR - 8CR', min: 75000000, max: 80000000 },
  { label: '8CR - 8.5CR', min: 80000000, max: 85000000 },
  { label: '8.5CR - 9CR', min: 85000000, max: 90000000 },
  { label: '9CR - 9.5CR', min: 90000000, max: 95000000 },
  { label: '9.5CR - 10CR', min: 95000000, max: 100000000 },
  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 30CR', min: 200000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
  { label: '100CR+++', min: 1000000000, max: 9999999999 },
];

const leaseRangeButtons = [
  { label: '1L - 2L', min: 100000, max: 200000 },
  { label: '2L - 3L', min: 200000, max: 300000 },
  { label: '3L - 4L', min: 300000, max: 400000 },
  { label: '4L - 5L', min: 400000, max: 500000 },
  { label: '5L - 10L', min: 500000, max: 1000000 },
  { label: '10L - 15L', min: 1000000, max: 1500000 },
  { label: '15L - 20L', min: 1500000, max: 2000000 },
  { label: '20L - 25L', min: 2000000, max: 2500000 },
  { label: '25L - 30L', min: 2500000, max: 3000000 },
  { label: '30L - 35L', min: 3000000, max: 3500000 },
  { label: '35L - 40L', min: 3500000, max: 4000000 },
  { label: '40L - 50L', min: 4000000, max: 5000000 },
  { label: '50L - 60L', min: 5000000, max: 6000000 },
  { label: '60L - 70L', min: 6000000, max: 7000000 },
  { label: '70L - 80L', min: 7000000, max: 8000000 },
  { label: '80L - 90L', min: 8000000, max: 9000000 },
  { label: '90L - 1CR', min: 9000000, max: 10000000 },
  { label: '1CR - 1.25CR', min: 10000000, max: 12500000 },
  { label: '1.25CR - 1.5CR', min: 12500000, max: 15000000 },
  { label: '1.5CR - 2CR', min: 15000000, max: 20000000 },
  { label: '2CR - 2.5CR', min: 20000000, max: 25000000 },
  { label: '2.5CR - 3CR', min: 25000000, max: 30000000 },
  { label: '3CR - 3.5CR', min: 30000000, max: 35000000 },
  { label: '3.5CR - 4CR', min: 35000000, max: 40000000 },
  { label: '4CR - 4.5CR', min: 40000000, max: 45000000 },
  { label: '4.5CR - 5CR', min: 45000000, max: 50000000 },
  { label: '5CR - 6CR', min: 50000000, max: 60000000 },
  { label: '6CR - 7CR', min: 60000000, max: 70000000 },
  { label: '7CR - 8CR', min: 70000000, max: 80000000 },
  { label: '8CR - 9CR', min: 80000000, max: 90000000 },
  { label: '9CR - 10CR', min: 90000000, max: 100000000 },
  { label: '10CR - 15CR', min: 100000000, max: 150000000 },
  { label: '15CR - 20CR', min: 150000000, max: 200000000 },
  { label: '20CR - 25CR', min: 200000000, max: 250000000 },
  { label: '25CR - 30CR', min: 250000000, max: 300000000 },
  { label: '30CR - 40CR', min: 300000000, max: 400000000 },
  { label: '40CR - 50CR', min: 400000000, max: 500000000 },
  { label: '50CR - 60CR', min: 500000000, max: 600000000 },
  { label: '60CR - 70CR', min: 600000000, max: 700000000 },
  { label: '70CR - 80CR', min: 700000000, max: 800000000 },
  { label: '80CR - 90CR', min: 800000000, max: 900000000 },
  { label: '90CR - 100CR', min: 900000000, max: 1000000000 },
  { label: '100CR+++', min: 1000000000, max: 9999999999 },
];

const getRangeButtons = (pathname) => {
  if (
    pathname.includes('/Buy-details') ||
    pathname.includes('/Buy-saves') ||
    pathname.includes('/postbank_detail') ||
    pathname.includes('/new-saves') ||
    pathname.includes('/new-list') ||
    pathname.includes('/hot-property-details') ||
    pathname.includes('/hot-property-saves')
  ) {
    return purchaseRangeButtons;
  } else if (pathname.includes('/details') || pathname.includes('/rent-saves')) {
    return rentRangeButtons;
  } else if (pathname.includes('/lease_details') || pathname.includes('/lease_save')) {
    return leaseRangeButtons;
  }
  return purchaseRangeButtons;
};

const getInitialMax = (pathname) => {
  if (pathname.includes('/details') || pathname.includes('/rent-saves')) return 9999999999;
  if (pathname.includes('/lease_details') || pathname.includes('/lease_save')) return 9999999999;
  return 100000000000;
};

const formatPrice = (value) => {
  if (value === 0) return 'No Min';
  if (value >= 10000000) return `${value / 10000000} Cr`;
  if (value >= 100000) return `${value / 100000} L`;
  if (value >= 1000) return `${value / 1000} K`;
  return value;
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const CustomSearchBar = ({
  value,
  onChange,
  onSearch,              // ✅ NEW: called with parsed structured query
  onPriceFilterChange,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const paperRef = useRef(null);
  const modalRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPriceRange, setSelectedPriceRange] = useState(null);
  const [tempSelectedRange, setTempSelectedRange] = useState(null);
  const [customRange, setCustomRange] = useState([0, getInitialMax(location.pathname)]);
  const [sliderMax, setSliderMax] = useState(getInitialMax(location.pathname));

  const currentRangeButtons = getRangeButtons(location.pathname);

  // Hide filter button on specific routes
  const hideFilterRoutes = ['/user-buy', '/user-bestdeals', '/user-rent', '/user-lease'];
  const hideFilter = hideFilterRoutes.includes(location.pathname);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (anchorEl) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [anchorEl]);

  const handleTuneClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => setAnchorEl(null);

  useEffect(() => {
    if (anchorEl) setTempSelectedRange(selectedPriceRange);
  }, [anchorEl, selectedPriceRange]);

  const handleRangeButtonSelect = (range) => {
    setCustomRange([range.min, range.max]);
    setTempSelectedRange({
      label: range.label,
      min: range.min,
      max: range.max,
    });
    setSliderMax(range.max > sliderMax ? range.max : sliderMax);
  };

  const handleSliderChangeTemp = (e, newValue) => {
    setCustomRange(newValue);
    setTempSelectedRange({
      label: `${formatPrice(newValue[0])} - ${formatPrice(newValue[1])}`,
      min: newValue[0],
      max: newValue[1],
    });
    if (newValue[1] > sliderMax) setSliderMax(newValue[1]);
  };

  const handleApplyFilter = () => {
    setSelectedPriceRange(tempSelectedRange);
    if (onPriceFilterChange) onPriceFilterChange(tempSelectedRange);
    handleMenuClose();
  };

  const clearPriceFilter = () => {
    setSelectedPriceRange(null);
    setTempSelectedRange(null);
    setCustomRange([0, getInitialMax(location.pathname)]);
    setSliderMax(getInitialMax(location.pathname));
    if (onPriceFilterChange) onPriceFilterChange(null);
    handleMenuClose();
  };

  const handleClearInput = () => {
    onChange({ target: { value: '' } });
    // ✅ Notify parent that search was cleared
    if (onSearch) onSearch({ type: 'empty', raw: '' });
  };

  // ✅ Universal search submit
  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = (value || '').trim();

    // Parse the query into { type, location, pincode, propertyType, price, raw }
    const parsed = parseSearchQuery(trimmed);

    // Bubble up to parent so it can filter listings
    if (onSearch) {
      // Merge the currently selected price filter (from the modal) if any,
      // unless the typed query itself specified a price.
      const merged = { ...parsed };
      if (
        selectedPriceRange &&
        merged.price == null
      ) {
        merged.minPrice = selectedPriceRange.min;
        merged.maxPrice = selectedPriceRange.max;
        merged.priceLabel = selectedPriceRange.label;
      }
      onSearch(merged);
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Paper
        ref={paperRef}
        component="form"
        elevation={0}
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 32,
          borderRadius: '30px',
          px: 0.8,
          backgroundColor: '#f2f5f7',
          border: '1px solid black',
          mx: 0.5,
          my: 0,
        }}
      >
        {/* Back Button */}
        <IconButton
          onClick={() => navigate(-1)}
          size="small"
          sx={{ color: 'black', p: 0.5 }}
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
        </IconButton>

        {/* Search Input — now universal */}
        <InputBase
          sx={{ ml: 1, flex: 1, fontSize: '13.5px' }}
          placeholder="Search area, city, pincode, property type, price..."
          value={value}
          onChange={onChange}
        />

        {/* Clear Input */}
        {value && (
          <IconButton
            onClick={handleClearInput}
            size="small"
            sx={{ color: 'black', p: 0.5 }}
          >
            <Close sx={{ fontSize: 18 }} />
          </IconButton>
        )}

        {/* Search Icon — triggers handleSubmit → parse + onSearch */}
        <IconButton
          type="submit"
          size="small"
          sx={{ color: 'black', p: 0.5 }}
        >
          <Search sx={{ fontSize: 18 }} />
        </IconButton>

        {/* Filter Icon - hidden on specific routes */}
        {!hideFilter && (
          <IconButton
            sx={{ color: 'black', p: 0.5 }}
            onClick={handleTuneClick}
            aria-label="filter"
            size="small"
          >
            <Tune sx={{ fontSize: 18 }} />
          </IconButton>
        )}
      </Paper>

      {/* Price Filter Modal */}
      {!hideFilter && anchorEl && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              zIndex: 1299,
            }}
            onClick={handleMenuClose}
          />

          <div
            ref={modalRef}
            style={{
              position: 'fixed',
              top: '43%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 1300,
              backgroundColor: 'white',
              width: '330px',
              maxHeight: '70vh',
              boxShadow: '0px 5px 15px rgba(0,0,0,0.2)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              borderRadius: '10px',
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                px: 2,
                py: 1,
                fontWeight: 'bold',
                flexShrink: 0,
                color: PRIMARY_BROWN,
              }}
            >
              Select Price Range
            </Typography>
            <Divider sx={{ flexShrink: 0 }} />

            <Box sx={{ px: 2, py: 2, flexShrink: 0 }}>
              <Slider
                value={customRange}
                onChange={handleSliderChangeTemp}
                min={0}
                max={sliderMax}
                step={1000}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => formatPrice(value)}
                sx={{
                  color: PRIMARY_BROWN,
                  '& .MuiSlider-thumb': {
                    backgroundColor: PRIMARY_BROWN,
                    '&:hover, &.Mui-focusVisible': {
                      boxShadow: `0 0 0 8px rgba(107, 54, 32, 0.16)`,
                    },
                  },
                  '& .MuiSlider-track': {
                    backgroundColor: PRIMARY_BROWN,
                    borderColor: PRIMARY_BROWN,
                  },
                  '& .MuiSlider-rail': { backgroundColor: '#d1d1d1' },
                  '& .MuiSlider-valueLabel': { backgroundColor: PRIMARY_BROWN },
                }}
              />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                <Typography variant="caption">{formatPrice(customRange[0])}</Typography>
                <Typography variant="caption">{formatPrice(customRange[1])}</Typography>
              </Box>
            </Box>

            <Divider sx={{ flexShrink: 0 }} />

            <Box
              sx={{
                px: 2,
                py: 2,
                flex: 1,
                minHeight: 0,
                overflowY: 'auto',
                '&::-webkit-scrollbar': { width: 6 },
                '&::-webkit-scrollbar-thumb': {
                  background: 'rgba(107, 54, 32, 0.35)',
                  borderRadius: 3,
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: 'rgba(107, 54, 32, 0.55)',
                },
              }}
            >
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: 1,
                }}
              >
                {currentRangeButtons.map((range) => {
                  const isRangeActive = tempSelectedRange?.label === range.label;
                  return (
                    <Button
                      key={range.label}
                      variant={isRangeActive ? 'contained' : 'outlined'}
                      size="small"
                      sx={{
                        borderRadius: '16px',
                        textTransform: 'none',
                        fontSize: '0.6rem',
                        minWidth: 'auto',
                        px: 1,
                        py: 0.5,
                        minHeight: '30px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        backgroundColor: isRangeActive ? PRIMARY_BROWN : 'transparent',
                        color: isRangeActive ? '#fff' : PRIMARY_BROWN,
                        borderColor: PRIMARY_BROWN,
                        '&:hover': {
                          backgroundColor: isRangeActive
                            ? PRIMARY_BROWN_HOVER
                            : 'rgba(107, 54, 32, 0.08)',
                          borderColor: PRIMARY_BROWN_HOVER,
                        },
                      }}
                      onClick={() => handleRangeButtonSelect(range)}
                    >
                      {range.label}
                    </Button>
                  );
                })}
              </Box>
            </Box>

            <Divider sx={{ flexShrink: 0 }} />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                px: 2,
                py: 1,
                flexShrink: 0,
              }}
            >
              <Button
                onClick={clearPriceFilter}
                sx={{
                  color: PRIMARY_BROWN,
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: 'rgba(107, 54, 32, 0.08)' },
                }}
              >
                CLEAR
              </Button>
              <Button
                onClick={handleApplyFilter}
                variant="contained"
                sx={{
                  backgroundColor: PRIMARY_BROWN,
                  fontWeight: 'bold',
                  '&:hover': { backgroundColor: PRIMARY_BROWN_HOVER },
                }}
              >
                APPLY
              </Button>
            </Box>
          </div>
        </>
      )}
    </Box>
  );
};

export default CustomSearchBar;